import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  HStack,
  Table,
  Tag,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from '@chakra-ui/react'
import {
  FinancialReport,
  StaysReservationReport,
} from '../../../repositories/ReportRepository'

interface PropertyReservationsAccordionProps {
  reportData: FinancialReport
}

export function PropertyReservationsAccordion({
  reportData,
}: PropertyReservationsAccordionProps) {
  const formatCurrency = (value: number | null) => {
    if (value === null) {
      return 'N/A'
    }
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value)
  }

  return (
    <Box>
      <Heading size="md" mb={4}>
        Reservas por Propriedade
      </Heading>
      <Accordion allowMultiple defaultIndex={[0]}>
        {Object.entries(reportData.properties_reservations).map(
          ([propertyId, reservations]) => (
            <AccordionItem
              key={propertyId}
              borderWidth="1px"
              borderRadius="md"
              mb={4}
              boxShadow="sm"
            >
              <h2>
                <AccordionButton _expanded={{ bg: 'gray.100' }}>
                  <Box flex="1" textAlign="left">
                    <HStack>
                      <Text fontWeight="bold">Propriedade:</Text>
                      <Tag colorScheme="blue">{propertyId}</Tag>
                    </HStack>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <VStack spacing={4} align="stretch">
                  <Table variant="simple" size="sm">
                    <Thead>
                      <Tr>
                        <Th>Reserva</Th>
                        <Th>Hóspede</Th>
                        <Th>Período</Th>
                        <Th isNumeric>Noites</Th>
                        <Th isNumeric>Valor Total</Th>
                        <Th isNumeric>Repasse</Th>
                        <Th isNumeric>Taxa de limpeza</Th>
                        <Th isNumeric>Lucro</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {(reservations as StaysReservationReport[]).map(
                        (reservation) => (
                          <Tr key={reservation.id}>
                            <Td>{reservation.stays_code}</Td>
                            <Td>{reservation.client.name}</Td>
                            <Td>
                              {new Date(
                                `${reservation.check_in_date}T00:00:00-03:00`
                              ).toLocaleDateString()}{' '}
                              -{' '}
                              {new Date(
                                `${reservation.check_out_date}T00:00:00-03:00`
                              ).toLocaleDateString('pt-BR')}
                            </Td>
                            <Td isNumeric>{reservation.night_count}</Td>
                            <Td isNumeric color="green.500" fontWeight="bold">
                              {formatCurrency(reservation.reserve_total)}
                            </Td>
                            <Td isNumeric color="red.500" fontWeight="bold">
                              {formatCurrency(
                                reservation.total_forward_fee +
                                  reservation.company_commission
                              )}
                            </Td>
                            <Td isNumeric color="red.500" fontWeight="bold">
                              {formatCurrency(reservation.total_cleaning_fee)}
                            </Td>
                            <Td isNumeric color="blue.500" fontWeight="bold">
                              {formatCurrency(
                                reservation.reserve_total -
                                  (reservation.total_forward_fee +
                                    reservation.company_commission +
                                    reservation.total_cleaning_fee)
                              )}
                            </Td>
                          </Tr>
                        )
                      )}
                    </Tbody>
                  </Table>
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )
        )}
      </Accordion>
    </Box>
  )
}
